import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon, MinusIcon } from 'lucide-react';
import * as React from 'react';

import { cn } from '../utils';

export type CheckboxProps = React.ComponentProps<
  typeof CheckboxPrimitive.Root
> & { id: string };

function Checkbox({ id, className, checked, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      id={id}
      data-testid={id}
      data-slot="checkbox"
      className={cn(
        'peer border-foreground/20 bg-background data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow  focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground data-[state=indeterminate]:border-primary',
        className,
      )}
      checked={checked}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        {checked !== 'indeterminate' && <CheckIcon className="size-3.5" />}
        {checked === 'indeterminate' && <MinusIcon className="size-3.5" />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
